import React from 'react';

export default (props) => (
    <svg width="60px" height="60px" viewBox="0 0 46 53" version="1.1" {...props} xmlns="http://www.w3.org/2000/svg">
    <g stroke={props.stroke || "#535353"} strokeWidth="2" fill="none">
        <path d="M27.341524,11.9631422 L30,0 C30,0 23.7826757,3.97340822 21.4220338,3.97340822 C18.7826757,3.97340822 15,0 15,0 L17.658476,11.9631422 C19.2179078,11.3324063 20.8379076,11 22.5,11 C24.1620924,11 25.7820922,11.3324063 27.341524,11.9631422 Z" id="Rectangle-1492"></path>
        <path d="M45,52 C45,29.3563253 34.9264069,11 22.5,11 C10.0735931,11 0,29.3563253 0,52 L45,52 Z" id="Oval-1381"></path>
        <path d="M27.9628488,11.3259155 C27.9628488,11.3259155 31.3057317,6.15574969 35.6098409,6.15574936" id="Path-3373"></path>
        <path d="M41.5227612,8.29153465 C41.5227612,8.29153465 39.3546815,12.6259799 27.9002187,11.5116041" id="Path-3374"></path>
        <path d="M25,30 C25,28.3431458 23.6568542,27 22,27 C20.3431458,27 19,28.3431458 19,30 C19,31.6568542 20.3431458,33 22,33" id="Oval-1383"></path>
        <path d="M22,39 L22,41" id="Line-325"></path>
        <path d="M22,25 L22,27" id="Line-326"></path>
        <path d="M19,36 C19,37.6568542 20.3431458,39 22,39 C23.6568542,39 25,37.6568542 25,36 C25,34.3431458 23.6568542,33 22,33" id="Oval-1382"></path>
    </g>
</svg>
);
